import { PAGE_NAME } from "@wattpad/client-platform-web-events";
import { getStoryReadingEligibility } from "../../../../helpers/ads/get-ad-eligibility";
import { isMatureGatedContent } from "../../../../helpers/is-mature-gated-content";
import * as readingGateExperiment from "../../../../helpers/experiments/reading-gate";

(function(window, wattpad, app) {
  "use strict";

  app.router.on(
    "route:storyReading",
    app.router.filter(["getTranslations", "getCategories"], function(
      partId,
      slug,
      pageNum,
      commentId,
      replyId,
      queryParams
    ) {
      var redirectParams = wattpad.utils.getRedirectParams();
      var partId = parseInt(partId, 10),
        model = new app.models.StoryPartModel({
          id: partId
        }),
        isComment = !!(commentId && commentId.toString().match(/[0-9_]+/)),
        // isDeeplinkedReply indicates whether the deeplinked comment is a reply to a parent comment.
        isDeeplinkedReply = !!(replyId && replyId.toString().match(/[0-9_]+/));

      let promises = [],
        deepLinkedComment;
      if (isNaN(partId)) {
        app.router.trigger("route:error-404", "story");
        return;
      }
      if (!wattpad.utils.appOn()) {
        pageNum = pageNum ? parseInt(pageNum, 10) + 1 : 2;
      }

      // AUDI-4617: Initialize mutedUsers to get the correct option
      // (Mute/Unmute user) in comment-item-options
      if (
        wattpad.utils.currentUser().get("username") &&
        window.store &&
        !window.store.getState().profileData.hasLoadad
      ) {
        promises.push(
          Promise.resolve(
            window.store.dispatch(
              window.app.components.actions.initializeMutedUsers(
                wattpad.utils.currentUser().get("username")
              )
            )
          )
        );
      }

      if (isComment) {
        /*
         * We always pass in the commentId (whether it is a deeplinked parent comment or reply comment) because we need to
         * render the parent comment for context even if the deeplinked comment is only a reply.
         */
        deepLinkedComment = new app.models.CommentModel(
          {
            id: commentId
          },
          {
            isDeepLink: true,
            commentIdToHighlight: replyId || commentId,
            isDeeplinkedReply: isDeeplinkedReply,
            errorHandlerMixinDisabled: true
          }
        );

        promises.push(
          new Promise(resolve => {
            deepLinkedComment
              .fetch()
              .then(
                result => resolve(result),
                () => resolve({ id: commentId })
              );
          })
        );
      }

      let adEligibility = [];

      model
        .fetch()
        .then(() => {
          const userCountryCode = wattpad.testGroups
            ?.IS_IN_MATURE_CONTENT_GATING
            ? "TR"
            : wattpad.userCountryCode;

          const shouldBlockReader = isMatureGatedContent(
            wattpad.utils.currentUser().authenticated(),
            model.get("group").mature,
            userCountryCode
          );

          if (shouldBlockReader) {
            var view = new app.views.Authentication({
              page: "fullScreen",
              nexturl: window?.location?.href
                ? window.location.href
                : model.get("url"),
              model: new app.models.Authsignup(),
              storyId: Number(model.get("group").id),
              partId: Number(partId)
            });

            app.transitionTo(view, {
              hasHeader: true,
              hasFooter: true
            });
            return;
          }

          if (!model.get("group").readerBrowseEligibility?.eligible) {
            var view = new app.views.StoryReading({
              blockLoggedinReader: true
            });

            app.transitionTo(view, {
              hasHeader: true,
              hasFooter: true
            });
            return;
          }

          // Reading gate experiment: fire the bucket-assignment analytics event
          // for logged-out users. Parts-read tracking happens in the transition
          // layer after the gate check, so the check sees parts-read as of the
          // previous navigation.
          if (!wattpad.utils.currentUser().authenticated()) {
            const uuid = wattpad.utils.getCookie("wp_id");
            if (uuid) {
              readingGateExperiment.sendBucketEvent(uuid);
            }
          }

          Promise.all(promises)
            .then(() => {
              // ADS-885: Ads Pageview Event
              if (typeof __atha !== "undefined") {
                var id = __atha.sendPageView(
                  "reading",
                  parseInt(model.get("group").id, 10),
                  model.get("id"),
                  model.get("group"),
                  model.attributes
                );
                model.set("pageviewId", id);
              }
              return new Promise(resolve => {
                getStoryReadingEligibility({
                  story_id: Number(model.get("group").id),
                  part_id: Number(partId)
                })
                  .then(response => {
                    adEligibility = response;
                    return resolve();
                  })
                  .catch(() => {
                    return resolve();
                  });
              });
            })
            .then(() => {
              const story = model.get("group");

              if (!story.isPaywalled) {
                // No need to fetch metadata if story isn't paid
                return;
              }

              const storyId = story.id;
              return window.store.dispatch(
                window.app.components.actions.fetchPaidContentMetadata(
                  storyId,
                  story.parts
                )
              );
            })
            .then(function() {
              model.getPage(pageNum || 1).then(function(page) {
                model.set("pageNumber", pageNum || 1);

                var storyText = page ? page.get("text") : "",
                  isPreview = !!redirectParams?.preview,
                  // Vietnamese is special-cased to deal with scrapers with good SEO
                  isVietnamese = parseInt(app.get("language"), 10) === 19,
                  isFirstPublish = !!redirectParams?.firstPublish,
                  isPostPublishModal = app.views.WorksWriter
                    ? app.currentView instanceof app.views.WorksWriter &&
                      !isPreview &&
                      !model.get("draft")
                    : !!redirectParams?.isPostPublishModal,
                  deviceOptions = {},
                  storyTitle;

                if (isVietnamese) {
                  storyTitle = [
                    "Đọc Truyện" + model.get("title"),
                    model.get("group").title,
                    model.get("group").user.name,
                    "Wattpad"
                  ].join(" - ");
                } else {
                  storyTitle = [
                    model.get("title"),
                    model.get("group").title,
                    "Wattpad"
                  ].join(" - ");
                }

                var options = {
                  model: model,
                  storyText: storyText,
                  fromLanding:
                    app.currentView instanceof app.views.NewStoryDetails,
                  isPreview: isPreview,
                  deepLinkModel: deepLinkedComment,
                  isFirstPublish: isFirstPublish,
                  isPostPublishModal: isPostPublishModal,
                  adEligibility,
                  pageName: PAGE_NAME.reader
                };

                var view = new app.views.StoryReading(options);

                if (app.get("device").is.mobile) {
                  deviceOptions = {
                    footerOptions: {
                      appUrl: wattpad.utils.getAppLink("story-reading", model)
                    }
                  };
                }

                const isPaywalled = model.get("group").isPaywalled;
                const noIndex = model.get("group").noIndex;
                app.transitionTo(
                  view,
                  _.extend(
                    {
                      pageTitle: storyTitle,
                      hasHeader: true,
                      hasFooter: true,
                      noIndex: noIndex,
                      viewChangedCallback: function() {
                        view.updateScrollState(true);
                      },
                      branchMetadata: { isPaywalled }
                    },
                    deviceOptions
                  )
                );
              });
            });
        })
        .catch(function() {
          //  error handling
          app.router.trigger("route:error-404", "story");
        });
    })
  );
})(window, wattpad, window.app);
